// @flow
import styles from './LastSearch.less';

import React from 'react';
import { connect } from 'react-redux';

import { lastSearchClicked } from 'src/store/lastSearch/lastSearch';
import {
  ScreenReaderOnly,
  SearchIcon,
  ChevronIcon
} from 'seek-style-guide/react';
import NavLink from 'src/components/NavLink/NavLink';

type Props = {
  query: SearchParams,
  summary: string,
  onLinkClick: Function
};

const mapStateToProps = ({ lastSearch }) => ({
  query: lastSearch.query,
  summary: lastSearch.summary
});

const mapDispatchToProps = dispatch => ({
  onLinkClick: () => dispatch(lastSearchClicked())
});

const LastSearch = ({ query, summary, onLinkClick }: Props) => (
  <div>
    <ScreenReaderOnly>Last Search: </ScreenReaderOnly>
    <NavLink
      onClick={onLinkClick}
      className={styles.link}
      location={{
        pathname: '/jobs',
        query
      }}
      title={`Last Search: ${summary}`}
      data-automation="lastSearchLink"
    >
      <SearchIcon standard className={styles.searchIcon} />
      <span className={styles.summaryContainer}>
        <span className={styles.summary} data-automation="lastSearchSummary">
          <span className={styles.summaryOutline}>{summary}</span>
        </span>
        <ChevronIcon direction="right" className={styles.chevronIcon} small />
      </span>
    </NavLink>
  </div>
);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LastSearch);
